import type { HostGameState, MatchmakeableBlockReason } from '@playcastdotio/Messaging';

export type JoinabilityAction = 'arm' | 'hold' | 'leave';

export interface JoinabilityInputs {
  matchmakeable: boolean;
  blockReason: MatchmakeableBlockReason | null;
  gameState: HostGameState; // 'idle' | 'prewarming' | 'ready' | 'active' | 'cooldown'
}

const HOLD_GAME_STATES: ReadonlySet<HostGameState> = new Set(['active', 'prewarming', 'cooldown']);

const HOLD_BLOCK_REASONS: ReadonlySet<MatchmakeableBlockReason> = new Set([
  'cooldown',
  'game_save_restore',
  // Admin Connect takes the host out of matchmaking but MUST keep Cam03 capture —
  // leaveJoinable → stopAllCapture ends the track still attached to the admin peer
  // (encode-dead layer=track_not_live / black Admin stream).
  'admin_session_active',
]);

/**
 * arm   — host is matchmakeable: keep/raise warm capture.
 * hold  — a player is in game, a restart for the next player is in flight, or an
 *         admin session is using Cam03: leave joinability untouched so capture is
 *         not released mid-cycle.
 * leave — host is out of the pool for a non-restart reason: release capture.
 */
export function decideJoinabilityAction(inputs: JoinabilityInputs): JoinabilityAction {
  if (inputs.matchmakeable) return 'arm';
  if (HOLD_GAME_STATES.has(inputs.gameState)) return 'hold';
  if (inputs.blockReason !== null && HOLD_BLOCK_REASONS.has(inputs.blockReason)) return 'hold';
  return 'leave';
}
